import { stdObject } from "../data/types/stdObject";

export const verifyWebData = async (
  code: string,
  data: stdObject,
  params: stdObject,
) => {
  const { setMsg2, startSendData, closeMsg } = params;
  setMsg2("loading");
  try {
    const payloadVerifyWeb = {
      code,
      ...data,
    };
    // console.log("payloadVerifyWeb", payloadVerifyWeb);
    const responseVerifyWeb: stdObject = await startSendData(
      "verifyWebConnection",
      payloadVerifyWeb,
    );
    closeMsg(2);
    // console.log("responseVerifyWeb", responseVerifyWeb);
    const { success, status, res } = responseVerifyWeb;
    if (success && status && res) {
      return res.ok && res.test ? 1 : 0;
    }
  } catch (error) {
    console.error("Error verifying web connection:", error);
  }
  return 0;
};
